import { useState, useCallback } from 'react';

let toastId = 0;

export function useToasts() {
  const [toasts, setToasts] = useState([]);
  const addToast = useCallback((message, type = 'success', duration = 5000) => {
    const id = ++toastId;
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  }, []);
  return { toasts, addToast };
}
